import React from 'react';
import { useLocale } from 'next-intl';
import SAR from '@/public/SAR';

type SizeOfImages = 'small' | 'medium' | 'large' | 'exLarge';

type TProps = {
  price: number;
  isHaveDiscount?: boolean;
  size: SizeOfImages;
  className?: string;
};

const sizeConfig: Record<SizeOfImages, { imageSize: string; textSize: string }> = {
  small: {
    imageSize: 'w-[0.875rem] h-[0.875rem] sm:w-[1rem] sm:h-[1rem]',
    textSize: 'text-[0.875rem] sm:text-[1rem]',
  },
  medium: {
    imageSize: 'w-[1rem] h-[1rem] sm:w-[1.15rem] sm:h-[1.15rem]',
    textSize: 'text-[1rem] sm:text-[1.15rem]',
  },
  large: {
    imageSize: 'w-[1.25rem] h-[1.25rem] sm:w-[1.5rem] sm:h-[1.5rem]',
    textSize: 'text-[1.25rem] sm:text-[1.5rem]',
  },
  exLarge: {
    imageSize: 'w-[1.375rem] h-[1.375rem] sm:w-[1.75rem] sm:h-[1.75rem]',
    textSize: 'text-[1.5rem] sm:text-[1.75rem]',
  },
};

const SaudiRealls = ({ price, size, isHaveDiscount, className }: TProps) => {
  const currentLang = useLocale() as 'ar' | 'en';
  const formattedPrice = new Intl.NumberFormat(currentLang === 'ar' ? 'ar-SA' : 'en-US').format(
    price,
  );

  return (
    <div className={`${className} flex items-center gap-1 sm:gap-2 ltr:flex-row-reverse`} dir="ltr">
      <div className="relative flex items-center gap-0.5 sm:gap-1">
        <SAR className={sizeConfig[size].imageSize} />

        <div className="flex items-center gap-0.5 sm:gap-1">
          <p className={`flex items-center justify-center ${sizeConfig[size].textSize}`}>
            {formattedPrice}
          </p>
        </div>

        {isHaveDiscount && (
          <div className="absolute top-1/2 left-0 h-[1px] w-full bg-zinc-500 line-through"></div>
        )}
      </div>
    </div>
  );
};

export default SaudiRealls;
